// extracted by mini-css-extract-plugin
export var activeFilterButton = "_lh-c";
export var backButton = "_lh-4";
export var backIcon = "_lh-5";
export var chevronShortcut = "_lh-6";
export var container = "_lh-1";
export var editor = "_lh-8";
export var editorWrapper = "_lh-7";
export var prefix = "_lh-2";
export var searchIcon = "_lh-3";
export var suffix = "_lh-9";
export var suffixContent = "_lh-a";
export var suffixText = "_lh-b";
export var wrapper = "_lh-0";